import {DataObjectId} from 'yougile-model'
import {Sync} from '../client/sync'
import {isBlocked} from '../components/dashboard/dashboard-utils'
import {globals} from './globals-base'

export class User {
  public static canReceiveDirectMessages(userId: DataObjectId): boolean {
    const user = Sync.getCurrentSandbox()
      .getAllUsers(false)
      .find(u => u.id === userId)

    if (!user) {
      return false
    }

    return !isBlocked(userId) && userId !== globals.currentUserId
  }
}
